import React, { useMemo } from 'react';
import './indicacionDetalle.scss';
import { Grid } from '@mui/material';
import { parsedCurrency } from "../../../../utils/mathUtils";
import { generateColumnsDefaultConfiguration } from '../../../../components/dataGrid/columnHelpers';
import DataGridGenerico from '../../../../components/dataGrid/DataGridGenerico';

const formatCantidad = (cantidadDiaria) => {
    const match = (cantidadDiaria?.toString() || '').match(/^(-?\d+(?:[.,]\d+)?)(.*)$/);
    if (!match) return cantidadDiaria;
    const [, numero, resto] = match;
    return parsedCurrency(numero) + resto;
};

export const IndicacionDetalleIndicacion = ({ indicacion, esMedico }) => {

    const initialColumns = (esMedico) ? [
        {
            field: 'nombre',
            headerName: 'Nombre',
            flex: 0.2
        },
        {
            field: 'cantidadDiaria',
            headerName: 'Cantidad diaria',
            flex: 0.2,
            valueGetter: (cantidadDiaria) => {
                return formatCantidad(cantidadDiaria);
            }
        },
        {
            field: 'unidad',
            headerName: 'Unidad',
            flex: 0.08
        }
    ] : [{
        field: 'nombre',
        headerName: 'Nombre',
        flex: 0.5
    },
    {
        field: 'presentacion',
        headerName: 'Presentación',
        flex: 0.25,
        valueGetter: (presentacion) => {
            return formatCantidad(presentacion);
        }
    },
    {
        field: 'cantidadDiaria',
        headerName: 'Cantidad diaria',
        flex: 0.25,
        valueGetter: (cantidadDiaria) => {
            return formatCantidad(cantidadDiaria);
        }
    },
    {
        field: 'proporcionDiaria',
        headerName: 'Proporción diaria',
        flex: 0.2,
        valueGetter: (proporcionDiaria) => {
            return proporcionDiaria + ' %';
        }
    },
    {
        field: 'costoUnidad',
        headerName: 'Costo unitario',
        flex: 0.2,
        valueGetter: (costoUnidad) => {
            return '$ ' + costoUnidad;
        }
    },
    {
        field: 'costoTotal',
        headerName: 'Costo total',
        flex: 0.2,
        valueGetter: (costoTotal) => {
            return '$ ' + costoTotal;
        }
    },
    ];

    const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns, true), [indicacion?.insumos]);

    return (
        <Grid container className='contrato-card-white'>
            <Grid size={{ xs: 12 }}>
                <div className='section-title'>Indicación</div>
            </Grid>
            <Grid container spacing={2} size={{ xs: 12 }}>
                <Grid size={{ xs: 6, md: 2 }}>
                    <div className='contrato-card-label'>Número</div>
                    <div>{(indicacion?.idIndicacion != '') ? indicacion?.idIndicacion : '-'}</div>
                </Grid>
                <Grid size={{ xs: 12, md: 3 }}>
                    <div className='contrato-card-label'>Período</div>
                    <div>{(indicacion?.periodo != '') ? indicacion?.periodo : '-'}</div>
                </Grid>
                {
                    !esMedico &&
                    <Grid size={{ xs: 6, md: 3 }}>
                        <div className='contrato-card-label'>Proporción diaria</div>
                        <div>{(indicacion?.proporcionDiaria != '') ? indicacion?.proporcionDiaria + ' %' : '-'}</div>
                    </Grid>
                }
                <Grid size={{ xs: 6, md: 12 }}>
                    <div className='contrato-card-label'>Detalle de indicación</div>
                    <DataGridGenerico
                        columns={columns}
                        rows={indicacion?.insumos}
                        toolbar={false}
                        hideFooter={true}
                        key={indicacion?.idIndicacion}
                    />
                </Grid>
            </Grid>
        </Grid>
    )
}